import { buildMiddleware, ServerConnection } from '@paragon/data-connections';

import { normalizeObject } from '../utilities/dataNormalization';

const normalizationMiddleware = buildMiddleware(normalizeObject);
const SealingServer = new ServerConnection('sealingServerApiUrl', normalizationMiddleware);

export interface ParsedJobMetaData {
  name?: string | null;
  designCode?: string | null;
  designProgram?: string | null;
  lotNumber?: string | null;
  address?: string | null;
  city?: string | null;
  subdivision?: string | null;
  model?: string | null;
  windExposureCategory?: string | null;
  windSpeed?: string | null;
  windCode?: string | null;
  meanRoofHeight?: string | null;
  roofLoad?: string | null;
  floorLoad?: string | null;
}

export function pGetMiTekJobMetaData(treFileContents: string, ansFileContents: string): Promise<ParsedJobMetaData> {
  return SealingServer.post('mitek/getJobMetaData', { data: { treFileContents, ansFileContents } });
}
